// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hx1t","colMin":"styles_colMin__1-zmW"};